import { SWReactCountryIcons } from "@similarweb/icons";
import FilterButtonLabel from "app/pages/sales-intelligence/sub-modules/signals/components/filters/shared/FilterDropdown/FilterButtonLabel/FilterButtonLabel";
import styled from "styled-components";

export const StyledFilterButtonLabel = styled(FilterButtonLabel)`
    align-items: center;

    ${SWReactCountryIcons} {
        height: 100%;
        margin-right: 8px;
    }
`;
